import React from 'react';
import Layout from "@/Shared/Layout";
import {InertiaLink, usePage} from "@inertiajs/inertia-react";
import useCheckbox from "@/Hooks/useCheckbox";
import PaginateCount from "@/Shared/PaginateCount";
import TableHeadSort from "@/Shared/TableHeadSort";
import Pagination from "@/Shared/Pagination";
import CategoriesSearchFilter from "@/Pages/Categories/Assets/CategoriesSearchFilter";
import CategoryActionBtns from "@/Pages/Categories/Assets/CategoryActionBtns";
import CategoriesBottomPanel from "@/Pages/Categories/Assets/CategoriesBottomPanel";

const Index = () => {
  const {categories} = usePage().props;

  const {
    data,
    meta: {links}
  } = categories;

  const {
    checked,
    checkboxesParent,
    handleCheck,
    handleCheckAll,
    parentCheckbox
  } = useCheckbox(data, 'category_id')

  return (
    <div>
      <div className='mb-3 flex justify-between items-center'>
        <h1 className="text-3xl font-bold">Categories</h1>
        <InertiaLink
          className="btn-default focus:outline-none"
          href={route('categories.create')}
        >
          <span>Create</span>
          <span className="hidden md:inline"> Category</span>
        </InertiaLink>
      </div>

      <div className="flex items-center justify-between mb-6">
        <CategoriesSearchFilter/>

        <PaginateCount/>
      </div>

      <div className="overflow-x-auto bg-white rounded shadow">
        <table className="w-full table-auto text-sm">
          <thead>
          <tr className="font-bold text-left">
            <th className="px-1 pt-5 pb-4 w-1">_</th>
            <th className='px-1 pt-5 pb-4 w-12 text-center'>Logo</th>
            <TableHeadSort customClassName='px-3 pt-5 pb-4 w-1' sortName='category_id' title='ID'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4' sortName='category_title' title='Title'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4' sortName='relative_uri' title='Relative URL'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4 w-10 pr-20' sortName='showonline' title='Status'/>
            <th className="pt-5 pb-4 w-10 pr-20">Actions</th>
          </tr>
          </thead>
          <CategoriesBottomPanel parentCheckbox={parentCheckbox} checked={checked} handleCheckAll={handleCheckAll}/>
          <tbody ref={checkboxesParent}>
          {data.map(({
                       category_id,
                       category_title,
                       relative_uri,
                       showonline,
                       def_image_logo
                     }) => (
            <tr
              key={category_id}
              className="hover:bg-gray-100 focus-within:bg-gray-100"
            >
              <td className="border-t">
                <div className="flex items-center px-1 py-4 focus:text-indigo-700 focus:outline-none">
                  <input
                    type="checkbox"
                    name={category_id}
                    onChange={handleCheck} />
                </div>
              </td>
              <td className='border-t'>
                <InertiaLink
                  href={route('categories.edit', category_id)}
                  className='flex justify-center px-1 py-4 focus:text-indigo-700 focus:outline-none'
                >
                  {def_image_logo ? (
                    <img
                      src={def_image_logo}
                      className='block w-10 h-5 mr-2 -my-2'
                    />
                  ) : <>-</>}
                </InertiaLink>
              </td>
              <td className="border-t">
                <InertiaLink
                  tabIndex="1"
                  className="flex items-center px-3 py-4 focus:text-indigo focus:outline-none"
                  href={route('categories.edit', category_id)}
                >
                  {category_id}
                </InertiaLink>
              </td>
              <td className="border-t">
                <InertiaLink
                  tabIndex="-1"
                  href={route('categories.edit', category_id)}
                  className="flex items-center px-1 py-4 focus:text-indigo focus:outline-none"
                >
                  {category_title}
                </InertiaLink>
              </td>
              <td className="border-t">
                <InertiaLink
                  tabIndex="-1"
                  href={route('categories.edit', category_id)}
                  className="flex items-center px-1 py-4 focus:text-indigo focus:outline-none"
                >
                  {relative_uri}
                </InertiaLink>
              </td>
              <td className="border-t">
                <InertiaLink
                  tabIndex="-1"
                  href={route('categories.edit', category_id)}
                  className="flex items-center px-1 focus:outline-none"
                >
                  {showonline === 1 ? 'Online' : 'Offline'}
                </InertiaLink>
              </td>
              <td className="w-px border-t">
                <CategoryActionBtns id={category_id} isShow={showonline}/>
              </td>
            </tr>
          ))}
          {data.length === 0 && (
            <tr>
              <td className="px-1 py-4 border-t" colSpan="4">
                No coupons found.
              </td>
            </tr>
          )}
          </tbody>
        </table>
      </div>
      <Pagination links={links}/>
    </div>
  );
};

Index.layout = page => <Layout title="Categories" children={page}/>;

export default Index;
